import React, { useState } from 'react';
import {
  Box,
  IconButton,
} from '@mui/material';
import UploadImagesInput from '../shared/UploadImagesInput';
import OutfitForm from './OutfitForm';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from 'react-router-dom';

const NewOutfits = () => {
  const [unsavedPictures, setUnsavedPictures] = useState([]);
  const navigate = useNavigate();

  const handleOutfitImgChange = (files) => {
    setUnsavedPictures(files);
  }

  const onOutfitSaved = () => {
    setUnsavedPictures(unsavedPictures.slice(1))
  }

  const handleGoHome = () => {
    navigate("/");
  };


  if (unsavedPictures.length === 0) {
    return (
      <Box>
        <Box style={{ padding: '2rem' }}>
          <Box sx={{ marginBottom: '3rem', display: 'flex', marginTop: 5 }}>
            <IconButton
              onClick={handleGoHome}
            >
              <ArrowBackIosIcon />
            </IconButton>
            <UploadImagesInput onChange={handleOutfitImgChange} />
          </Box>
        </Box>
      </Box>
    );
  }
  return (
    <OutfitForm outfitImageFile={unsavedPictures[0]} onOutfitSaved={onOutfitSaved} remainingPicturesCount={unsavedPictures.length - 1} />
  )
};

export default NewOutfits;
